import type { ChatI18n } from '../types.js';

export const CHAT_I18N_TR: ChatI18n = {
  headerTitle: 'Ürün Uzmanı',
  inputPlaceholder: 'Ürün ara, soru sor',
  inputAriaLabel: 'Mesajınızı yazın',
  sendButton: 'Gönder',
  closeButton: 'Kapat',
  openButton: 'Sohbeti aç',
  newChatButton: 'Yeni sohbet',
  poweredBy: 'Gengage ile',
  errorMessage: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  retryButton: 'Tekrar Dene',
  loadingMessage: 'İsteğinizi inceliyorum...',
  loadingSequenceGeneric: [
    'İsteğinizi inceliyorum...',
    'Ürün detaylarını inceliyorum...',
    'Kontrol ediyorum...',
    'Bulduklarımı değerlendiriyorum...',
    'Detayları inceliyorum...',
  ],
  loadingSequencePanel: [
    'En ilgili detayları inceliyorum',
    'En güçlü sinyalleri kontrol ediyorum',
    'Bu görünümü sizin için hazırlıyorum',
  ],
  loadingSequenceComparison: [
    'Ürün farklarını inceliyorum',
    'En güçlü farkları ve ödünleşimleri kontrol ediyorum',
    'Karşılaştırmayı sizin için hazırlıyorum',
  ],
  productCtaLabel: 'Satın Al',
  viewOnSiteLabel: 'Sitede Gör',
  attachImageButton: 'Resim ekle',
  attachMenuSelectPhoto: 'Fotoğraf Seç',
  attachMenuPaste: 'Yapıştır',
  clipboardNoImageMessage: 'Panoda görsel bulunamadı. Önce bir görsel kopyalayın veya dosya seçin.',
  removeAttachmentButton: 'Resmi kaldır',
  invalidFileType: 'Sadece JPEG, PNG ve WebP dosyaları destekleniyor.',
  fileTooLarge: "Dosya boyutu 5 MB'dan küçük olmalıdır.",
  aiTopPicksTitle: 'Sizin İçin En İyiler',
  roleWinner: 'Size Özel Seçimim',
  roleBestValue: 'En Uygun Fiyatlı',
  roleBestAlternative: 'En İyi Alternatif',
  viewDetails: 'Detayları Gör',
  groundingReviewCta: 'Yorumları Oku',
  groundingReviewSubtitle: '{count} yorum mevcut',
  variantsLabel: 'Varyantlar',
  sortRelated: 'Önerilen',
  sortPriceAsc: 'Fiyat düşükten yükseğe',
  sortPriceDesc: 'Fiyat yüksekten düşüğe',
  sortToolbarAriaLabel: 'Ürünleri sırala',
  compareSelected: 'Karşılaştır',
  productGridSectionCountLabel: '{count} ürün',
  compareMinHint: 'En az 2 ürün seçin',
  compareMaxHint: 'En fazla 5 ürün seçebilirsiniz',
  comparisonSelectLabel: 'Karşılaştırmak için seç',
  comparisonSelectedLabel: 'Seçildi',
  comparisonSelectCardHint: 'Karşılaştırmaya eklemek veya çıkarmak için kartın herhangi bir yerine dokunun.',
  comparisonPreparingLabel: 'Karşılaştırma tablosu hazırlanıyor…',
  panelTitleProductDetails: 'Ürün Detayı',
  panelTitleSimilarProducts: 'Benzer Ürünler',
  panelTitleComparisonResults: 'Karşılaştırma Sonuçları',
  panelTitleCategories: 'Kategoriler',
  panelTitleSearchResults: 'Arama Sonuçları',
  inStockLabel: 'Stokta',
  outOfStockLabel: 'Tükendi',
  findSimilarLabel: 'Benzerlerini Bul',
  galleryPrevAriaLabel: 'Önceki görsel',
  galleryNextAriaLabel: 'Sonraki görsel',
  beautyStylesPreparedTitle: 'Sizin için {count} farklı öneri yönü hazırladım',
  consultingOtherCompatibleProductsLabel: 'Diğer Uyumlu Ürünler',
  consultingFallbackGroupLabel: 'Öneri',
  consultingFallbackStyleLabel: 'Stil {index}',
  consultingStyleLoadingDescription:
    'Bu stil için ürünleri toplamaya devam ediyorum. Panel kısa süre içinde yenilenir.',
  consultingStyleUnavailableDescription:
    'Bu stil için şu anda yeterli ürün eşleşmesi çıkaramadım. Diğer stilleri inceleyebilirsiniz.',
  consultingStyleLoadingBadge: 'Yükleniyor',
  consultingStyleUnavailableBadge: 'Hazır değil',
  choicePrompterHeading: 'Kararsız mı kaldın?',
  choicePrompterSuggestion: 'Ürünleri seçip karşılaştırabilirsin',
  choicePrompterCta: 'Seç ve Karşılaştır',
  viewMoreLabel: 'Daha Fazla Göster',
  similarProductsLabel: 'Benzer Ürünler',
  addToCartButton: 'Sepete Ekle',
  addingToCartToast: 'Sepete ekleniyor...',
  addedToCartToast: 'Sepete eklendi',
  shareButton: 'Paylaş',
  productInfoTab: 'Ürün Bilgileri',
  specificationsTab: 'Teknik Özellikler',
  recommendedChoiceLabel: 'Önerilen Seçim',
  highlightsLabel: 'Öne Çıkan Özellikler',
  keyDifferencesLabel: 'Temel Farklar',
  specialCasesLabel: 'Özel Durumlar İçin',
  emptyReviewsMessage: 'Yorum özeti bulunamadı.',
  closeAriaLabel: 'Kapat',
  startChatLabel: 'Sohbete Başla',
  voiceButton: 'Sesli giriş',
  voiceListening: 'Dinleniyor...',
  voiceNotSupported: 'Sesli giriş bu tarayıcıda desteklenmiyor.',
  voicePermissionDenied: 'Mikrofon erişimi reddedildi.',
  voiceError: 'Sesli giriş hatası.',
  handoffHeading: 'Destek temsilcisine aktarılıyor',
  productNotFoundMessage: 'Bu ürün bilgisi şu an kullanılamıyor. Başka bir konuda yardımcı olabilirim.',
  stopGenerating: 'Yanıtı Durdur',
  offlineMessage: 'Çevrimdışısınız — bağlantı kurulduğunda mesajlar gönderilecek.',
  cartAriaLabel: 'Sepetim',
  favoritesAriaLabel: 'Favorilerim',
  historyAriaLabel: 'Sohbet geçmişi',
  historyPageTitle: 'Sohbet Geçmişi',
  historyImageAttachmentLabel: 'Görsel eklendi',
  emptyHistoryMessage: 'Henüz kaydedilmiş sohbet yok.',
  historyDeleteLabel: 'Sohbeti sil',
  historyDeleteConfirmMessage: 'Bu sohbet geçmişten silinsin mi? Bu işlem geri alınamaz.',
  showPanelAriaLabel: 'Sonuçları Göster',
  addToFavoritesLabel: 'Favorilere ekle',
  customerReviewsTitle: 'Müşteri Yorumları',
  togglePanelAriaLabel: 'Paneli aç/kapat',
  chatMessagesAriaLabel: 'Sohbet mesajları',
  suggestionsAriaLabel: 'Öneriler',
  previousSuggestionsAriaLabel: 'Önceki öneriler',
  moreSuggestionsAriaLabel: 'Daha fazla öneri',
  rollbackAriaLabel: 'Bu mesaja geri dön',
  backAriaLabel: 'Geri',
  forwardAriaLabel: 'İleri',
  closePanelAriaLabel: 'Paneli kapat',
  dismissAriaLabel: 'Kapat',
  cartAddErrorMessage: 'Üzgünüm sepete ekleyemedim, bir sorunla karşılaştım.',
  favoriteToggleErrorMessage: 'Favoriler güncellenemedi. Lütfen tekrar deneyin.',
  reviewFilterPositive: 'Olumlu',
  reviewFilterNegative: 'Olumsuz',
  decreaseLabel: 'Azalt',
  increaseLabel: 'Artır',
  reviewCustomersMentionSingular: '1 müşteri bahsediyor',
  reviewCustomersMentionPlural: 'müşteri bahsediyor',
  reviewSubjectsHeading: 'İncelemek için seçin',
  tryAgainButton: 'Tekrar dene',
  askSomethingElseButton: 'Başka bir şey sor',
  accountInactiveMessage: 'Bu hesap şu an aktif değil. Lütfen daha sonra tekrar deneyin.',
  favoritesPageTitle: 'Favorilerim',
  emptyFavoritesMessage: 'Henüz favori ürün yok. Bir ürünü kalp ikonuna tıklayarak favorilere ekleyebilirsin.',
  showFormerMessagesButton: '↑ Önceki mesajları göster',
  aiAnalysisAnalyzingLabel: 'Ürünler analiz ediliyor...',
  aiBrowseCategoriesTitle: 'Kategorilere Göz At',
  photoAnalysisBadge: 'Cilt Analizi',
  photoAnalysisStrengthsLabel: 'Öne Çıkanlar',
  photoAnalysisFocusLabel: 'Odak Noktaları',
  photoAnalysisCelebStyleLabel: 'Celeb Vibe Eşleşmesi',
  beautyPhotoStepTitle: 'Selfie ile kişiselleştir',
  beautyPhotoStepDescription: 'İstersen net bir profil fotoğrafı yükle, sana özel önerilerde bulunayım.',
  beautyPhotoStepUpload: 'Fotoğraf Yükle',
  beautyPhotoStepProcessing: 'Fotoğraf işleniyor...',
  beautyPhotoStepSkip: 'Geç',
  beautyPhotoStepSkipMessage: 'Fotoğraf adımını geçiyorum',
};
